import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const INSPECTION_BASE = config.api.REACT_APP_SPED_NORMATIVE_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getInspectionListQuery = params => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTIONS_QUERY}?${stringifyParams(params)}`
	);
};

export const getInspectionList = params => {
	const queryParams = {
		skip: 0,
		limit: 1000,
		sort_field: 'inspection_date',
		sort_order: -1,
		populate: true,
		...params,
	};

	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTIONS}?${stringifyParams(queryParams)}`
	);
};

export const getInspection = inspection_id => {
	const queryParams = {
		populate: true,
	};

	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTION}${inspection_id}?${stringifyParams(
			queryParams
		)}`
	);
};

export const addNewInspectionApi = inspection => {
	return apiClient.create(`${INSPECTION_BASE}${url.POST_INSPECTION}`, inspection);
};

export const updateInspectionApi = inspection => {
	return apiClient.put(
		`${INSPECTION_BASE}${url.PUT_INSPECTION}${inspection._id}`,
		inspection
	);
};

export const deleteInspectionApi = inspection_id => {
	return apiClient.delete(`${INSPECTION_BASE}${url.DELETE_INSPECTION}${inspection_id}`);
};

export const getInspectionDashboardSummary = (params = {}) => {
	const query = stringifyParams(params);
	const sep = query ? '?' : '';
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_DASHBOARD_SUMMARY}${sep}${query}`
	);
};

export const getInspectionsByAuthorityYear = (params = {}) => {
	const query = stringifyParams(params);
	const sep = query ? '?' : '';
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTIONS_BY_AUTHORITY_YEAR}${sep}${query}`
	);
};
